"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfGetNotificationsResponseDataDto = instanceOfGetNotificationsResponseDataDto;
exports.GetNotificationsResponseDataDtoFromJSON = GetNotificationsResponseDataDtoFromJSON;
exports.GetNotificationsResponseDataDtoFromJSONTyped = GetNotificationsResponseDataDtoFromJSONTyped;
exports.GetNotificationsResponseDataDtoToJSON = GetNotificationsResponseDataDtoToJSON;
exports.GetNotificationsResponseDataDtoToJSONTyped = GetNotificationsResponseDataDtoToJSONTyped;
var PaginationDetailsDto_1 = require("./PaginationDetailsDto");
var NotificationItemDto_1 = require("./NotificationItemDto");
/**
 * Check if a given object implements the GetNotificationsResponseDataDto interface.
 */
function instanceOfGetNotificationsResponseDataDto(value) {
    if (!('notifications' in value) || value['notifications'] === undefined)
        return false;
    if (!('pagination' in value) || value['pagination'] === undefined)
        return false;
    if (!('totalUnreadCount' in value) || value['totalUnreadCount'] === undefined)
        return false;
    return true;
}
function GetNotificationsResponseDataDtoFromJSON(json) {
    return GetNotificationsResponseDataDtoFromJSONTyped(json, false);
}
function GetNotificationsResponseDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'notifications': (json['notifications'].map(NotificationItemDto_1.NotificationItemDtoFromJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoFromJSON)(json['pagination']),
        'totalUnreadCount': json['totalUnreadCount'],
    };
}
function GetNotificationsResponseDataDtoToJSON(json) {
    return GetNotificationsResponseDataDtoToJSONTyped(json, false);
}
function GetNotificationsResponseDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'notifications': (value['notifications'].map(NotificationItemDto_1.NotificationItemDtoToJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoToJSON)(value['pagination']),
        'totalUnreadCount': value['totalUnreadCount'],
    };
}
